import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { cva } from "../../../node_modules/class-variance-authority/dist/index.js";
import { forwardRef } from "react";
import { createPortal } from "react-dom";
import ScrollLock from "../../../node_modules/react-scrolllock/dist/index.js";
import { twMerge } from "../../../node_modules/tailwind-merge/dist/bundle-mjs.js";
import { drawerAnimation } from "../../helpers/drawer.animations.js";
import Backdrop from "../../../backdrop/components/Backdrop/Backdrop.js";
import { AnimatePresence } from "../../../node_modules/framer-motion/dist/es/components/AnimatePresence/index.js";
import { motion } from "../../../node_modules/framer-motion/dist/es/render/dom/motion.js";
const drawerVariants = cva(["fixed z-[81]", "overflow-x-hidden overflow-y-auto", "p-6 bg-floating-color"], {
  variants: {
    anchor: {
      right: "right-0 top-0 bottom-0 w-full md:w-[var(--drawer-width)]",
      left: "left-0 top-0 bottom-0 w-full md:w-[var(--drawer-width)]",
      top: "left-0 top-0 right-0",
      bottom: "left-0 bottom-0 right-0"
    }
  },
  defaultVariants: {
    anchor: "right"
  }
});
const Drawer = forwardRef((props, ref) => {
  const { open, onClose, children, anchor = "right", className, title, hideCloseButton = false, ...rest } = props;
  return createPortal(
    /* @__PURE__ */ jsx(AnimatePresence, { initial: false, mode: "wait", children: open && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(Backdrop, { show: open, onClick: onClose, className: "z-[80]" }),
      /* @__PURE__ */ jsx(ScrollLock, { children: /* @__PURE__ */ jsxs(
        motion.div,
        {
          ...rest,
          ...drawerAnimation[anchor],
          ref,
          className: twMerge(drawerVariants({ anchor, className })),
          children: [
            !hideCloseButton && /* @__PURE__ */ jsx(
              "button",
              {
                type: "button",
                className: "absolute top-[26px] right-6 z-[82] text-grayscale-500",
                onClick: onClose,
                children: /* @__PURE__ */ jsx(
                  "svg",
                  {
                    width: "1.2em",
                    height: "1.2em",
                    viewBox: "0 0 15 15",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /* @__PURE__ */ jsx(
                      "path",
                      {
                        d: "M11.782 4.032a.575.575 0 10-.813-.814L7.5 6.687 4.032 3.218a.575.575 0 00-.814.814L6.687 7.5l-3.469 3.468a.575.575 0 00.814.814L7.5 8.313l3.469 3.469a.575.575 0 00.813-.814L8.313 7.5l3.469-3.468z",
                        fill: "currentColor",
                        fillRule: "evenodd",
                        clipRule: "evenodd"
                      }
                    )
                  }
                )
              }
            ),
            title && /* @__PURE__ */ jsx("h4", { className: "text-xl font-semibold mb-4", children: title }),
            children
          ]
        }
      ) })
    ] }) }),
    document.body
  );
});
export {
  Drawer as default
};
//# sourceMappingURL=Drawer.js.map
